import { getSubstitutedUserFlag } from "./localstorage";

/**
 * @returns {'N' | 'L' | 'S'} - The user type:
 *   - 'N': Normal user (customer)
 *   - 'L': Local user (anyone with one of sinchersEmailDomains)
 *   - 'S': Sudo user (when Sinch users use Login as functionality)
 */
export const getUserType = (email: string): "N" | "L" | "S" => {
  const sinchersEmailDomains = [
    "@sinch.com",
    "@on.sinch.com",
    "@mailgun.com",
    "@messagemedia.com",
    "@messagemedia.com.au",
    "@inteliquent.com",
    "@messengerpeople.com",
    "@clxcommunications.com",
    "@symsoft.com",
    "@clxnetworks.com",
  ];
  const isSinchEmail = sinchersEmailDomains.some((domain) =>
    email.toLowerCase().endsWith(domain)
  );

  if (getSubstitutedUserFlag()) {
    return "S";
  } else if (isSinchEmail) {
    return "L";
  } else {
    return "N";
  }
};
